import React from 'react';

import PrintTemplateGroupDialog from './PrintTemplateGroupDialog';

const PrintLbxHtmlDialog = ({
  open,
  onClose,
  deviceId,
  printTemplateGroups,
  defaultFilename = 'device.zip'
}) => (
  <PrintTemplateGroupDialog
    open={open}
    onClose={onClose}
    printTemplateGroups={printTemplateGroups}
    endpoint="printing/lbx-html/"
    buildBody={(templateGroup) => ({
      device_id: deviceId,
      template_group_id: templateGroup
    })}
    defaultFilename={defaultFilename}
    errorMessage="Failed to generate LBX"
  />
);

export default PrintLbxHtmlDialog;
